// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kHpla","container":"Footer_container__MJyCl","column":"Footer_column__wS2ec","heading":"Footer_heading__bTa6F","bottomRow":"Footer_bottomRow__zguz4"};